import { render, staticRenderFns } from "./job_home.vue?vue&type=template&id=24588807&scoped=true"
import script from "./job_home.vue?vue&type=script&lang=js"
export * from "./job_home.vue?vue&type=script&lang=js"
import style0 from "./job_home.vue?vue&type=style&index=0&id=24588807&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24588807",
  null
  
)

export default component.exports